import React, { useMemo } from 'react';
import { FormRenderer } from '@kevlarcon/formkit';
import '../styles/formkitTheme.css';
import Modal from './Modal';
import { formKitClient } from '../api/formkitClient';
import { partnersApi } from '../api/partners';

/**
 * The header's "Add partner" button — a staff-entered single listing.
 * Reuses `@kevlarcon/formkit`'s `FormRenderer` for the whole schema-driven
 * form (fields, widgets, validation), but its `handleSubmit` always calls
 * `client.submitSubmission` with a hardcoded `status: 'submitted'`, with no
 * hook to change either — wrong for a staff-added listing, which should land
 * `imported` like a bulk-imported row (see partners/views.py's `add_partner`
 * docstring). This wrapper client overrides only `submitSubmission` to hit
 * that action instead of formkit's own `submit_submission`; every other
 * client method (schema fetch, draft autosave) still goes through the same
 * `formKitClient` `PartnerFormBuilder` already uses.
 */
const AddPartnerModal: React.FC<{
  formId: number;
  onClose: () => void;
  onAdded: () => void;
}> = ({ formId, onClose, onAdded }) => {
  const client = useMemo(
    () => ({
      ...formKitClient,
      submitSubmission: (fId: number, data: Record<string, unknown>) =>
        partnersApi.addPartner(fId, data),
    }),
    [],
  );

  return (
    <Modal
      title="Add partner"
      hint="Adds one school to your roster as unclaimed — it confirms and fills in the rest when it claims the listing."
      onClose={onClose}
      wide
      testId="partners-add-modal"
    >
      <FormRenderer client={client} formId={formId} onSubmitted={onAdded} />
    </Modal>
  );
};

export default AddPartnerModal;
